import React from "react";
import { ServiceFaqs } from "../../types/serviceDetail";
import PackageAccordion from "../PackageAccordian/PackageAccordian";

interface Props {
  serviceFaqs: ServiceFaqs[];
  sectionTitle: string | null;
  line: string | null;
  isPage?: boolean;
}

const ServiceFaq: React.FC<Props> = ({
  serviceFaqs,
  sectionTitle,
  line,
  isPage = false,
}) => {
  const renderTitle = (title: string | null) => {
    if (!title) return null;
    const TitleTag = isPage ? "h3" : "p";
    return (
      <TitleTag
        className="text-center font-16 text-black ff-semibold mb-4"
        dangerouslySetInnerHTML={{ __html: title }}
      />
    );
  };

  const renderLine = (line: string | null) => {
    if (!line) return null;
    return (
      <p
        className="font-12 text-grey ff-normal text-center"
        dangerouslySetInnerHTML={{ __html: line }}
      />
    );
  };

  return (
    <div className="container-fluid py-2 py-md-4">
      <div className="row">
        {renderTitle(sectionTitle)}
        {renderLine(line)}

        <div className="col-md-12 p-0">
          <div className="modal-faq">
            <PackageAccordion faqData={serviceFaqs} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceFaq;